import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import MainContent from "./HgoRequestComponents/MainContent";
import { FaBars, FaTimes } from "react-icons/fa";
import RollIdPrompt from "../CommonComponents/RollIdPrompt";
import { RollIdProvider } from "../CommonComponents/RollIdContext"; // Import the provider
import Tabs from "../CommonComponents/Tabs";
import Sidebar from "../CommonComponents/Sidebar";

const HgoRequest = () => {
  const navigate = useNavigate();
  const { userType } = useParams(); // Get the user type from the URL
  console.log("User Type:", userType);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [reload, setReload] = useState(0);
  const [rollId, setRollId] = useState("");

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleRollIdSubmit = (id) => {
    setRollId(id);
  };

  useEffect(() => {
    if (!userType || (userType !== "hgo" && userType !== "monazam")) {
      // Redirect to an error page or a default page if the userType is invalid
      navigate("/");
    }
  }, [userType, navigate]);
  return (
    <RollIdProvider>
      {/* Wrap everything inside the RollIdProvider */}
      <div className="dashboard-layout d-flex">
        <Sidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          relaod={reload}
          setReload={setReload}
        />
        <div className={`main-content ${isSidebarOpen ? "blurred" : ""}`}>
          {/* Hamburger Menu for mobile screens */}
          <div className="d-md-none d-flex align-items-center sidebar-logo-bg py-3 px-1">
            <button className="btn" onClick={toggleSidebar}>
              {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
            <img
              src="/assets/logo.png"
              alt="Logo"
              className="img-fluid logo pe-5"
              style={{ height: "40px" }}
            />
          </div>
          <RollIdPrompt onRollIdSubmit={handleRollIdSubmit} />
          <div className="me-3 mt-3">
            <Tabs />
          </div>
          <MainContent reload={reload} />
        </div>
      </div>
    </RollIdProvider>
  );
};

export default HgoRequest;
